import MapMarkerWithInfoWindow from './MapMarkerWithInfoWindow';

export default MapMarkerWithInfoWindow;